import React, {useEffect, useRef} from 'react';
import { useParams } from 'react-router-dom';

const MtvContainer = ({mtvSetup, ...rest}) => {


    useEffect(()=>{

        const {mtvApp} = window;
        
        var lSetupObj = {
            ...mtvSetup,
            id: "mtv-container12",
            //play_rid:4589,
            //play_sid: 52357,
            
            
        };
        // var lQsRid = mtTools.getParameterByName("rid");
        // if(mtValidator.isNumber(lQsRid))
        //     lSetupObj.play_rid = parseInt(lQsRid);
        // if(mtValidator.isNumber(lQsSid))
        //     lSetupObj.play_sid = parseInt(lQsSid);
        // if(!mtValidator.isNullOrWhitespace(lQsPlayId))
        //         lSetupObj.playIdConfig = true;

        mtvApp.setup(lSetupObj);
        
        return ()=>mtvApp.destroy();

    },[])

    return ( <div id="mtv-container12"></div> );
}
 
export default MtvContainer;